export const enum IconStackType {
  Index = "i",
}
